module.exports = __webpack_public_path__ + "static/media/assess.c62b3fc3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/subscription/assess.jpg
// module id = 2921
// module chunks = 0